import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DoneIcon from "@material-ui/icons/Done";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(11),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 120,
    [theme.breakpoints.down("md")]: {
      width: 100,
      paddingLeft: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 60,
      paddingLeft: 20,
    },
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
    [theme.breakpoints.down("md")]: {
      paddingRight: 20,
    },
  },
  body: {
    marginTop: 24,
    marginBottom: 110,
    [theme.breakpoints.down("md")]: {
      paddingRight: 20,
      paddingLeft: 20,
      marginTop: 24,
      marginBottom: 80,
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 20,
      paddingLeft: 20,
      marginTop: 24,
      marginBottom: 24,
    },
  },
  bodybol: {
    marginTop: 32,
    marginBottom: 32,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      marginTop: 0,
      marginBottom: 0,
      // justifyContent: "space-evenly",
    },
  },
  inputLine: {
    width: "50%",
    color: "#1a2633",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: 28,
    },
  },
  buttons: {
    float: "left",

    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      backgroundColor: "#ffffff",
      display: "inline-block",
      fontSize: 18,
      width: 80,
      height: 36,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  textField1: {
    width: 272,
    height: 40,
    paddingLeft: 12,
    borderColor: "rgb(133, 133, 133)",
    borderRadius: "5px",
    backgroundSize: "12px 12px",
    background: `url(/images/ex/simple_down_arrow.jpg) no-repeat 96% 50%`,
    backgroundColor: "#ffffff",
    fontSize: 16,
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 30px)",
      backgroundSize: "12px 12px",
      backgroundColor: "#ffffff",
      background: `url(/images/ex/simple_down_arrow.jpg) no-repeat 98% 50%`,
    },
    [theme.breakpoints.down("sm")]: {
      backgroundSize: "12px 12px",
      backgroundColor: "#ffffff",
      background: `url(/images/ex/simple_down_arrow.jpg) no-repeat 96% 50%`,
    },
    appearance: "none",
    "&::-ms-expand": {
      display: "none",
    },
  },
  inputView: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  inputTitle: {
    width: 120,
    [theme.breakpoints.down("md")]: {
      width: 100,
    },
    [theme.breakpoints.down("sm")]: {
      width: 60,
    },
  },
  sex: {
    paddingRight: 6,
  },
  footer: {
    width: "100%",
    textAlign: "center",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 12,
    },
  },
  footerAB: {
    width: "100%",
    textAlign: "center",
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      height: 56,
      fontSize: 18,
    },
  },
  tip: {
    width: 30,
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

const FormList = ({
  score,
  onSexChange,
  onKGChange,
  onAgeChange,
  onCmChange,
  onPageMove,
  inputElAge,
  inputElCm,
  inputElKg,
}) => {
  const classes = useStyles();
  const arrayView = (startNum, endNum) => {
    let array = [];
    for (let index = startNum; index < endNum + 1; index++) {
      array.push(index);
    }
    return array;
  };

  const cmArray = arrayView(100, 230);
  const ageArray = arrayView(40, 90);
  const kgArray = arrayView(30, 150);
  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.root}
      >
        <Grid className={classes.info}>
          <Typography variant="h3">기본정보</Typography>
        </Grid>
        <Grid className={classes.infoLine}></Grid>
      </Grid>
      <Grid
        container
        className={classes.body}
        justify="space-between"
        alignItems="center"
        direction="column"
      >
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Grid className={classes.inputLine} container alignItems="center">
            <Grid className={classes.inputTitle}>
              <Typography variant="h4">성별</Typography>
            </Grid>
            <Grid className={classes.buttons}>
              <Grid
                onClick={() => onSexChange(true)}
                className={`${score.sex ? "on" : "off"}`}
              >
                <Grid
                  container
                  alignItems="center"
                  justify={score.sex ? "space-around" : "center"}
                >
                  <Grid className={classes.icon}>
                    {score.sex ? (
                      <DoneIcon
                        style={{
                          fontSize: 21,
                          paddingLeft: 8,
                          paddingRight: 2,
                        }}
                      />
                    ) : (
                      <div style={{ height: 21 }}></div>
                    )}
                  </Grid>
                  <Grid className={score.sex ? classes.sex : null}>남자</Grid>
                </Grid>
              </Grid>
              <Grid
                onClick={() => alert("전립선암은 남성만 선택가능합니다.")}
                className={`${!score.sex ? "on" : "off"}`}
              >
                <Grid
                  container
                  alignItems="center"
                  justify={!score.sex ? "space-around" : "center"}
                >
                  <Grid className={classes.icon}>
                    {!score.sex ? (
                      <DoneIcon
                        style={{
                          fontSize: 21,
                          paddingLeft: 8,
                          paddingRight: 2,
                        }}
                      />
                    ) : (
                      <div style={{ height: 21 }}></div>
                    )}
                  </Grid>
                  <Grid className={!score.sex ? classes.sex : null}>여자</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.inputLine} container alignItems="center">
            <Grid className={classes.inputTitle}>
              <Typography variant="h4">신장</Typography>
            </Grid>
            <Grid className={classes.inputView}>
              {/* <TextField
                type="number"
                inputRef={inputElCm}
                value={score.cm}
                onChange={(e) => onCmChange("cm", e)}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                className={classes.textField1}
                variant="outlined"
                size="small"
              /> */}
              <select
                className={classes.textField1}
                value={score.cm}
                onChange={(e) => onCmChange("cm", e)}
                ref={inputElCm}
              >
                {cmArray.map((num, index) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={classes.tip}
              >
                <Typography variant="h4">Cm</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.bodybol} container alignItems="center">
          <Grid className={classes.inputLine} container alignItems="center">
            <Grid className={classes.inputTitle}>
              <Typography variant="h4">연령</Typography>
            </Grid>
            <Grid className={classes.inputView}>
              {/* <TextField
                className={classes.textField1}
                value={score.age}
                onChange={(e) => onCmChange("age", e)}
                variant="outlined"
                inputRef={inputElAge}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                size="small"
              /> */}
              <select
                className={classes.textField1}
                value={score.age}
                ref={inputElAge}
                onChange={(e) => onAgeChange("age", e)}
              >
                {ageArray.map((num, index) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={classes.tip}
              >
                <Typography variant="h4">세</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.inputLine} container alignItems="center">
            <Grid className={classes.inputTitle}>
              <Typography variant="h4">체중</Typography>
            </Grid>
            <Grid className={classes.inputView}>
              {/* <TextField
                type="number"
                value={score.kg}
                inputRef={inputElKg}
                onChange={(e) => onKGChange("kg", e)}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                className={classes.textField1}
                variant="outlined"
                size="small"
              /> */}
              <select
                className={classes.textField1}
                value={score.kg}
                onChange={(e) => onCmChange("kg", e)}
                ref={inputElKg}
              >
                {kgArray.map((num, index) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={classes.tip}
              >
                <Typography variant="h4">Kg</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormList;
